/**
 * Sequence enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Sequence step type labels
export const sequenceStepTypeLabels = {
    email: 'Email',
    sms: 'SMS',
    whatsapp: 'WhatsApp',
    voice_call: 'Voice Call',
    wait: 'Wait',
    condition: 'Condition',
    webhook: 'Webhook',
};
export const sequenceStepTypeValues = Object.keys(sequenceStepTypeLabels);
// Sequence version change type labels
export const sequenceVersionChangeTypeLabels = {
    created: 'Created',
    updated: 'Updated',
    published: 'Published',
    restored: 'Restored',
};
export const sequenceVersionChangeTypeValues = Object.keys(sequenceVersionChangeTypeLabels);
// Sequence execution status labels
export const sequenceExecutionStatusLabels = {
    pending: 'Pending',
    running: 'Running',
    completed: 'Completed',
    failed: 'Failed',
    canceled: 'Canceled',
};
export const sequenceExecutionStatusValues = Object.keys(sequenceExecutionStatusLabels);
//# sourceMappingURL=sequences.js.map